import { styled } from "goober";
import { Icon } from "../Icon";
import { Text } from "../Text";
import { Tooltip } from "../Tooltip";

const Badge = styled("div")`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 8px;
  background: var(--alpha4);
  border-radius: 38px;
  color: color-mix(in srgb, var(--text-primary) 30%, transparent);
`;

const tooltipContent =
  "This connector’s secrets are kept completely out of the view of workflows, steps, and code. 3B securely injects them into network requests, meaning they’re only ever used where they should be, and never revealed.";

export function SecureBadge() {
  return (
    <Tooltip content={tooltipContent}>
      <Badge>
        <Icon name="shield-check" size={12} />
        <Text variant="text-small-md">3B Secure</Text>
      </Badge>
    </Tooltip>
  );
}
